module.exports = __webpack_public_path__ + "img/forme.4b256c20.svg";